import React from "react";
import useGameStore from "../../context/GameContext";
import { assertWordSelectionItems, WordSelectionItem } from "../../types/game";
import { AllTogetherMode } from "../modes/AllTogetherMode";
import { SequentialMode } from "../modes/SequentialMode";
import { MatchingMode } from "../modes/MatchingMode";

export interface GamePanelProps {
  items: WordSelectionItem[];
  libraryName: string;
}

const GameContent: React.FC = () => {
  // 从 store 获取必要的状态和方法
  const {
    currentMode,
    selectedLibrary,
    currentLibrary,
    getCurrentLibraryItems,
    isGameActive,
    isTimerRunning,
    pauseGame,
    resumeGame,
    getFormattedTime,
  } = useGameStore();

  // 获取当前选中词库的内容
  const items = React.useMemo(() => getCurrentLibraryItems(), [currentLibrary]);
  const wordSelectionItems = assertWordSelectionItems(items);

  // 如果游戏未开始或没有选择题库，显示欢迎信息
  if (!isGameActive || !currentMode || !currentLibrary || !items) {
    return (
      <div className="game-content">
        <div className="welcome-container">
          <h2>欢迎使用词库练习系统</h2>
          <p>请从上方选择一个题库和模式，然后点击对应模式开始练习。</p>
          <div className="features-list">
            <h3>功能介绍:</h3>
            <ul>
              <li>消消乐模式 - 匹配单词和释义</li>
              <li>依次答题模式 - 一题一题地进行练习</li>
              <li>全部答题模式 - 一次性回答所有问题</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  // 根据当前模式动态渲染对应的游戏模式组件
  const renderGameMode = () => {
    // 传递给各模式组件的通用参数
    const commonProps = {
      items: wordSelectionItems,
      libraryName: currentLibrary,
    };

    switch (currentMode) {
      case "matching":
        return <MatchingMode {...commonProps} />;
      case "sequential":
        return <SequentialMode {...commonProps} />;
      case "allTogether":
        return <AllTogetherMode {...commonProps} />;
      default:
        return <div className="error-message">未知的游戏模式</div>;
    }
  };

  return (
    <div className="game-content">
      <div className="game-header">
        <h2>当前题库：{currentLibrary}</h2>
        {/* {!isTimerRunning && isGameActive && (
          <div className="paused-message">
            游戏已暂停 - 当前用时: {getFormattedTime()}
            <button className="resume-button" onClick={resumeGame}>
              继续游戏
            </button>
          </div>
        )} */}
      </div>

      {renderGameMode()}
    </div>
  );
};

export default GameContent;
